<template>
  <div v-if="visible" class="cpbe-modal">
    <div class="cpbe-box">
      <header class="cpbe-head">
        <div class="cpbe-title-wrap">
          <span class="cpbe-accent"></span>
          <span class="cpbe-title">{{ dialogTitle }}</span>
        </div>
        <button class="cpbe-close" type="button" @click="close">×</button>
      </header>
      <div v-loading="loading" class="cpbe-content">
        <div class="distribute-record-list">
          <el-empty v-if="!loading && !error && !records.length" description="暂无铺货日志" :image-size="80" />
          <div v-if="error && !loading" class="distribute-record-state">铺货日志加载失败</div>
          <div
            v-for="record in records"
            :key="record.id"
            class="distribute-record-item"
            :class="'is-' + recordType(record)">
            <div class="distribute-record-header">
              <span>
                {{ recordIcon(record) }}
                {{ record.distribute_status_text || record.platform_status_text || '铺货记录' }}
              </span>
              <div class="distribute-record-tags">
                <el-tag :type="distributeTag(record.distribute_status)" size="mini">
                  铺货：{{ record.distribute_status_text || '未知' }}
                </el-tag>
                <el-tag :type="platformTag(record.platform_status)" size="mini">
                  平台：{{ record.platform_status_text || '未知' }}
                </el-tag>
                <el-tag
                  v-if="record.platform_delete_status_text"
                  :type="Number(record.platform_delete_status) === 0 ? 'info' : 'danger'"
                  size="mini">
                  删除：{{ record.platform_delete_status_text }}
                </el-tag>
                <el-tag v-if="flagEnabled(record.platform_ban_status)" type="danger" size="mini">已封禁</el-tag>
                <el-tag v-if="flagEnabled(record.platform_stock_status)" type="warning" size="mini">售罄</el-tag>
              </div>
            </div>
            <div class="distribute-record-grid">
              <div>
                <span>店铺</span>
                {{ record.shop_name || record.mer_shop_id || '-' }}
              </div>
              <div>
                <span>店铺平台</span>
                {{ record.shop_type_text || '-' }}
              </div>
              <div>
                <span>平台商品 ID</span>
                {{ record.platform_product_id || '-' }}
              </div>
              <div>
                <span>消耗算力</span>
                {{ record.use_quota_num === undefined || record.use_quota_num === null ? '-' : record.use_quota_num }}
              </div>
              <div class="distribute-record-time">
                <span>创建时间</span>
                {{ record.created_at_text || '-' }}
              </div>
              <div class="distribute-record-time">
                <span>最后更新时间</span>
                {{ record.updated_at_text || '-' }}
              </div>
            </div>
            <div v-if="record.error_msg" class="distribute-record-error">错误原因：{{ record.error_msg }}</div>
          </div>
        </div>
      </div>
      <footer class="cpbe-foot"><button class="gx-cloud__btn" type="button" @click="close">关闭</button></footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DistributeRecordDialog',
  props: {
    visible: { type: Boolean, default: false },
    product: { type: Object, default: null }
  },
  data() {
    return { loading: false, error: false, records: [] }
  },
  computed: {
    dialogTitle() {
      const product = this.product || {}
      return `${product.title || '-'}（来源ID：${product.source_product_id || '-'}）`
    }
  },
  watch: {
    visible(value) {
      if (value) this.load()
    }
  },
  methods: {
    ...mapActions({ getRecords: 'ucenter/getCloudProductDistributeRecords' }),
    load() {
      this.loading = true
      this.error = false
      this.records = []
      const id = this.product && this.product.id
      if (!id) {
        this.loading = false
        this.error = true
        return
      }
      this.getRecords({
        id,
        success: (res) => {
          this.loading = false
          if (res && (res.code === 200 || res.code === 0)) this.records = Array.isArray(res.data) ? res.data : []
          else this.fail()
        },
        error: () => this.fail()
      })
    },
    fail() {
      this.loading = false
      this.error = true
      this.$message.error('获取铺货日志失败')
    },
    close() {
      this.$emit('update:visible', false)
    },
    distributeTag(status) {
      return Number(status) === 4 ? 'success' : Number(status) === 5 ? 'danger' : 'warning'
    },
    platformTag(status) {
      return Number(status) === 2 ? 'danger' : Number(status) === 4 ? 'success' : 'info'
    },
    flagEnabled(status) {
      return Number(status) === 1
    },
    recordType(record) {
      const text = `${record.distribute_status_text || ''}${record.platform_status_text || ''}`
      if (this.flagEnabled(record.platform_ban_status) || /封禁/.test(text)) return 'ban'
      if (/驳回/.test(text) || Number(record.distribute_status) === 5) return 'review'
      if (Number(record.distribute_status) === 3 || record.error_msg) return 'fail'
      if (Number(record.distribute_status) === 4) return 'success'
      return 'default'
    },
    recordIcon(record) {
      return { success: '✅', fail: '⚠️', review: '🚫', ban: '🔒', default: 'ℹ️' }[this.recordType(record)]
    }
  }
}
</script>

<style scoped>
.cpbe-modal {
  position: fixed;
  inset: 0;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
  font-family: 'Noto Sans SC', sans-serif;
}
.cpbe-box {
  width: 680px;
  max-width: 760px;
  min-width: 0;
  height: min(72vh, 600px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 56px rgba(0, 0, 0, 0.22);
}
.cpbe-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 12px 18px;
  background: #f5f0e8;
  border-bottom: 1px solid #e0e0ec;
}
.cpbe-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.cpbe-accent {
  width: 4px;
  height: 18px;
  border-radius: 2px;
  background: #c8443c;
}
.cpbe-title {
  overflow: hidden;
  color: #1a1a2e;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cpbe-close {
  border: 0;
  background: transparent;
  color: #999;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}
.cpbe-content {
  flex: 1;
  min-height: 0;
  padding: 14px 18px;
  overflow: hidden;
  background: #fafafa;
}
.cpbe-foot {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 10px 18px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
}
.cpbe-foot .gx-cloud__btn {
  height: 32px;
  padding: 0 18px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
}
.cpbe-foot .gx-cloud__btn:hover {
  border-color: #c8443c;
  background: #fff5f5;
  color: #c8443c;
}
.distribute-record-list {
  min-height: 180px;
  height: 100%;
  overflow-y: auto;
}
.distribute-record-state {
  padding: 40px 0;
  color: #909399;
  text-align: center;
}
.distribute-record-item {
  padding: 10px 12px;
  margin-bottom: 10px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #333;
  font-size: 11px;
}
.distribute-record-item.is-review {
  background: rgb(255 247 230);
  color: rgb(251 146 60);
  border: 1px solid #e4e7ed;
  border-left: 5px solid rgb(255 213 145);
}
.distribute-record-item.is-fail {
  background: rgb(255 245 245);
  border: 1px solid #e4e7ed;
  border-left: 5px solid rgb(200 68 60);
  color: rgb(200 68 60);
}
.distribute-record-item.is-success {
  background: #f0f9eb;
  border: 1px solid #e4e7ed;
  color: rgb(10, 184, 68);
  border-left: 5px solid rgb(25 167 72);
}
.distribute-record-item.is-ban {
  background: #f0f0f0;
  border-color: #c8c8c8;
  color: #555;
}
.distribute-record-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  color: inherit;
  font-size: 14px;
  font-weight: 500;
}
.distribute-record-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}
.distribute-record-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px 8px;
  margin-top: 4px;
}
.distribute-record-grid > div {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.distribute-record-grid .distribute-record-time {
  white-space: nowrap;
}
.distribute-record-grid span {
  margin-right: 6px;
  color: inherit;
  opacity: 0.7;
}
.distribute-record-error {
  padding-top: 4px;
  margin-top: 4px;
  color: inherit;
  word-break: break-all;
}
@media (max-width: 900px) {
  .cpbe-box {
    width: 100vw;
    min-width: 0;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
  .distribute-record-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 560px) {
  .cpbe-modal {
    padding: 0;
  }
  .distribute-record-header {
    flex-direction: column;
  }
  .distribute-record-tags {
    justify-content: flex-start;
  }
  .distribute-record-grid {
    grid-template-columns: 1fr;
  }
}
</style>
